import { create } from 'zustand';
import { AIEatEvent } from '@/components/ui/DebugAIEatNotification';

// Debug mode is enabled via VITE_DEBUG=true environment variable
export const DEBUG = typeof import.meta !== 'undefined' && import.meta.env?.VITE_DEBUG === 'true';

interface DebugStore {
  aiEatEvents: AIEatEvent[];
  addAIEatEvent: (event: Omit<AIEatEvent, 'id' | 'timestamp'>) => void;
  removeAIEatEvent: (id: string) => void;
  clearAllEvents: () => void;
}

export const useDebugStore = create<DebugStore>((set, get) => ({
  aiEatEvents: [],
  
  addAIEatEvent: (eventData) => {
    if (!DEBUG) return;
    
    const event: AIEatEvent = {
      ...eventData,
      id: Math.random().toString(36).substr(2, 9),
      timestamp: Date.now(),
    };
    
    set(state => ({
      aiEatEvents: [...state.aiEatEvents.slice(-20), event], // Keep last 20 events
    }));
  },
  
  removeAIEatEvent: (id) => {
    set(state => ({
      aiEatEvents: state.aiEatEvents.filter(e => e.id !== id),
    }));
  },
  
  clearAllEvents: () => {
    set({ aiEatEvents: [] });
  },
}));
